// TODO This is currently only used for apollo-client, but not for react router!
import { createBrowserHistory } from "history";
let history = createBrowserHistory();
export default history;
